import React, { useState } from 'react';
import MultiSelectField from '../components/MultiSelectField';
import { Box, Typography } from '@mui/material';

export default function Test() {
    const [selectedValue, setSelectedValue] = useState([]);
    const options = [
        'Option 1',
        'Option 2',
        'Option 3',
        'Option 4',
        'Option 5',
    ];

    return (
        <Box sx={{ p: 4 }}>
            <Typography variant="h5" gutterBottom>
                Test MultiSelectField
            </Typography>
            <MultiSelectField
                label="Select Options"
                value={selectedValue}
                items={options}
                onChange={(value) => setSelectedValue(value)}
            />
            <Typography variant="body1" sx={{ mt: 2 }}>
                Selected Value: {selectedValue}
            </Typography>
        </Box>
    );
}
